import React, { ReactNode, createContext, useContext, useState, useMemo, useCallback } from 'react'
import useDebouncedState from '~hooks/useDebouncedState'

interface Context {
    searchString: string
    setSearchString: (input: string) => void
    isSearching: boolean
    startSearching: () => void
    stopSearching: () => void
}

const SearchSlotContext = createContext<Context>({
    searchString: '',
    setSearchString: () => null,
    isSearching: false,
    startSearching: () => null,
    stopSearching: () => null,
})

export function SearchSlotProvider({ children }: { children: ReactNode }) {
    const [searchString, setSearchString] = useDebouncedState('')
    const setSearchStringFmt = useCallback((val: string) => setSearchString(val.trim()), [setSearchString])
    const [isSearching, setSearching] = useState(false)

    const startSearching = useCallback(() => {
        setSearching(true)
    }, [setSearching])

    const stopSearching = useCallback(() => {
        setSearching(false)
        setSearchString('')
    }, [setSearching, setSearchString])

    const contextValue = useMemo(() => {
        const value: Context = {
            searchString,
            setSearchString: setSearchStringFmt,
            isSearching,
            startSearching,
            stopSearching,
        }
        return value
    }, [searchString, setSearchStringFmt, isSearching, startSearching, stopSearching])

    return <SearchSlotContext.Provider value={contextValue}>{children}</SearchSlotContext.Provider>
}

export const useSearchSlotContext = () => useContext(SearchSlotContext)
